import React from 'react';
import clsx from 'clsx';
import { Typography, getTypographyDefaultColor, Space, Container, Col, Row } from '@ag1/ui';
import { HighlightedContent as HighlightedContentProps, SanityKeyed } from 'types/studio/studio';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';
import CustomPortableText from '../PortableText/PortableText';
import styles from './HighlightedContent.module.scss';
import { CommonSectionProps } from '../types';

const HighlightedContent = ({
  _key: key,
  superHeadline,
  headline,
  subtitle,
  text,
  background,
  padding,
  theme
}: SanityKeyed<HighlightedContentProps> & CommonSectionProps) => (
  <div
    className={clsx(
      background === 'stone' ? styles.bgStone : styles.bgWhite,
      getThemeCSSClass(theme)
    )}>
    <Container narrow id={key}>
      <Space
        top={{ xxs: 40, s: 60, m: 80, l: 100 }}
        bottom={{ xxs: 40, s: 60, m: 80, l: 100 }}
        className={clsx(getSectionPaddingClasses(styles, padding))}>
        <Row>
          <Col span={{ xxs: 12, l: 10 }} offset={{ l: 1 }} className={styles.col}>
            {superHeadline && (
              <Typography
                component="div"
                variant="subtitle"
                size="1"
                noPadding
                className={styles.commonShift}
                color={getTypographyDefaultColor(theme)}>
                <CustomPortableText value={superHeadline} />
              </Typography>
            )}
            {headline && (
              <Typography
                component="div"
                variant="headlineSans"
                size="2"
                noPadding
                className={styles.commonShift}
                color={getTypographyDefaultColor(theme)}>
                <CustomPortableText value={headline} />
              </Typography>
            )}
            {subtitle && (
              <Typography
                component="div"
                variant="headlineSans"
                size="2"
                noPadding
                className={(styles.commonShift, styles.subtitle)}
                color={getTypographyDefaultColor(theme)}>
                <CustomPortableText value={subtitle} />
              </Typography>
            )}
            {text && (
              <Typography
                component="div"
                variant="subtitle"
                size="2"
                noPadding
                className={clsx(styles.commonShift, styles.text)}
                color={getTypographyDefaultColor(theme)}>
                <CustomPortableText value={text} />
              </Typography>
            )}
          </Col>
        </Row>
      </Space>
    </Container>
  </div>
);

export default HighlightedContent;
